import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import db from '../../db/db';

const ValidateSession = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [tieneSesion, setTieneSesion] = useState(false);

    useEffect(() => {
        const verificar = async () => {
            const sesion = await db.sesion.toArray();
            setTieneSesion(sesion.length > 0);
            setLoading(false);
        };
        verificar();
    }, []);

    if (loading) return null;
    if (tieneSesion) return <Navigate to="/dashboard" />;
    return children;
};

export default ValidateSession;
